// extracted by mini-css-extract-plugin
export var accordion = "_dn-0";
export var chevron = "_dn-3";
export var closed = "_dn-2";
export var content = "_dn-4";
export var open = "_dn-1";
export var rotate = "_dn-5";